/* Product rail: arrow scrolling plus the optional category pills.

   The panels are rendered server-side and toggled with `hidden`, rather than
   replacing innerHTML the way the prototype's drawKit() does. That keeps the
   filter instant, keeps focus intact, and means the arrows never need
   rebinding — only re-syncing. */
(function () {
  'use strict';

  const H = window.Hystride;
  if (!H) return;

  H.register('product-rail', {
    mount(root) {
      const rails = H.initRails(root);
      const pills = Array.from(root.querySelectorAll('[data-rail-filter]'));
      const panels = Array.from(root.querySelectorAll('[data-rail-panel]'));

      const onPill = (e) => {
        const index = e.currentTarget.dataset.railFilter;

        pills.forEach((p) =>
          p.setAttribute('aria-pressed', p === e.currentTarget ? 'true' : 'false')
        );
        panels.forEach((p) => {
          p.hidden = p.dataset.railPanel !== index;
          if (!p.hidden) p.scrollLeft = 0;
        });

        // The disabled state of the arrows is wrong until the first scroll
        // unless we re-sync after the panel swaps. docs/01 §6.
        rails.forEach((r) => r.sync());
      };

      pills.forEach((p) => p.addEventListener('click', onPill));

      return { rails, pills, onPill };
    },

    unmount(root, s) {
      if (!s) return;
      s.rails.forEach((r) => r.destroy());
      s.pills.forEach((p) => p.removeEventListener('click', s.onPill));
    },
  });
})();
